module.exports = "/_next/static/images/WhatIsCustomerData@3x-666db2c3479f3d96a9307bb2d648dca9.webp";